import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { hasModule } from "../lib/rbac";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children, module, blockRoles, allowRoles }) {
    const { user, loading } = useAuth();
    if (loading || user === null) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <Loader2 className="w-6 h-6 animate-spin text-muted-foreground" />
            </div>
        );
    }
    if (!user) return <Navigate to="/login" replace />;
    if (module && !hasModule(user, module)) {
        return <Navigate to="/portal" replace />;
    }
    if (blockRoles && blockRoles.includes(user.role)) {
        return <Navigate to="/purchase-requests" replace />;
    }
    if (allowRoles && !allowRoles.includes(user.role)) {
        // Deep-link denied → back to portal (safe root every authed user can reach)
        return <Navigate to="/portal" replace />;
    }
    return children;
}
